// import React, { useEffect, useState } from "react";

// import Layout from "../components/Layout";
// import Drawer from "../components/Drawer";
// import Loader from "../components/Loader";
// import { toast } from "react-toastify";
// import axios from "axios";
// import {
//   baseUrl,
//   liveMatchesAllApi,
//   liveMatchesApi,
//   recentMatchesApi,
//   weeklyMatchesApi,
// } from "../api/api";
// import moment from "moment-timezone";
// import { useSelector } from "react-redux";
// import MatchLayout from "../components/MatchLayout";
// import classes from "../css/HomePage.module.css";
// import { useNavigate } from "react-router-dom";
// import MatchGridLayout from "../components/Match-Container/MatchGridLayout";
// import HeadingWithGrid from "../components/Headings/HeadingWithGrid";
// import MessageBoxSimple from "../components/Message-Box/MessageBoxSimple";
// import Heading from "../components/Heading";
// import Footer from "../components/Footer";

// const HomePage = () => {
//   const [loading, setLoading] = useState(true);
//   const [matches, setMatches] = useState([]);
//   const [recentMatches, setRecentMatches] = useState([]);
//   const [liveMatches, setLiveMatches] = useState([]);
//   const [todayMatches, setTodayMatches] = useState([]);
//   const [todayMatchesResults, setTodayMatchesResults] = useState([]);
//   const [weeklyMatches, setWeeklyMatches] = useState([]);
//   const { lang } = useSelector((state) => state.langSlice);

//   const navigate = useNavigate();

//   const fetchDataFromBackend = async (loader) => {
//     try {
//       if (loader?.loading) {
//         setLoading(true);
//       }
//       const res = await axios.get(`${baseUrl}${liveMatchesApi}`, {
//         timezone: moment.tz.guess(),
//         date: moment().tz(moment.tz.guess()).format("YYYY-MM-DD"),
//       });

//       // const res = await axios.get(`${baseUrl}${liveMatchesAllApi}`);

//       console.log(res, "res");

//       setMatches(res?.data?.response?.data);

//       // TODAY MATCHES PREMIERE LEAGUE
//       setTodayMatches(
//         res?.data?.response?.data.filter(
//           (data) =>
//             data.matchStatus != "Match Finished" && data.matchTime == null,
//         ),
//       );

//       // LIVE MATCHES PREMIERE LEAGUE
//       setLiveMatches(
//         res?.data?.response?.data.filter(
//           (data) =>
//             data.matchTime != null && data.matchStatus != "Match Finished",
//         ),
//       );

//       const liveData = res.data.response.data.length;
//       console.log("liveData ", liveData);

//       // ⛳ Redirect to /shortz if no live matches and it's first load
//       if (
//         liveData === 0 &&
//         loader?.loading &&
//         !localStorage.getItem("shortzRedirectedOnce")
//       ) {
//         toast.info(
//           "No live match right now. Redirecting to Football Shorts News...",
//           {
//             position: "top-center",
//             autoClose: 4000,
//           },
//         );

//         // Set flag to avoid repeating redirect
//         localStorage.setItem("shortzRedirectedOnce", "true");

//         setTimeout(() => {
//           navigate("/shortz");
//         }, 4000);
//       }

//       // TODAY MATCHES RESULTS PREMIERE LEAGUE
//       setTodayMatchesResults(
//         res?.data?.response?.data.filter(
//           (data) => data.matchStatus == "Match Finished",
//         ),
//       );

//       console.log(res, "response....");
//       setLoading(false);
//     } catch (error) {
//       setLoading(false);
//       toast.error(
//         error?.response?.data?.message ||
//           error?.data?.message ||
//           error?.message ||
//           error,
//       );
//     }
//   };

//   const fetchRecentMatchesFromBackend = async () => {
//     try {
//       setLoading(true);

//       const res = await axios.get(`${baseUrl}${recentMatchesApi}`, {
//         params: {
//           league_id: 39,
//         },
//       });

//       console.log(res.data, "recent matches response");

//       setRecentMatches(
//         res?.data?.response?.filter(
//           (data) => data.matchStatus === "Match Finished",
//         ),
//       );

//       setLoading(false);
//     } catch (error) {
//       setLoading(false);

//       toast.error(
//         error?.response?.data?.message ||
//           error?.message ||
//           "Something Went Wrong!",
//       );

//       console.log(error, "recent matches error");
//     }
//   };

//   const fetchWeeklyMatchesFromBackend = async () => {
//     try {
//       setLoading(true);

//       const res = await axios.get(`${baseUrl}${weeklyMatchesApi}`);

//       console.log(res.data, "response weekly matches");

//       setWeeklyMatches(
//         res?.data?.response?.filter((data) => data.matchTime == null),
//       );

//       setLoading(false);
//     } catch (error) {
//       setLoading(false);

//       toast.error(
//         error?.response?.data?.message ||
//           error?.message ||
//           "Something Went Wrong!",
//       );

//       console.log(error, "weekly matches error");
//     }
//   };

//   useEffect(() => {
//     // ✅ Clear redirect flag if older than 1 day
//     const redirectTimestamp = localStorage.getItem("shortzRedirectedAt");
//     const now = Date.now();

//     //one hout

//     if (redirectTimestamp && now - redirectTimestamp > 3600000) {
//       localStorage.removeItem("shortzRedirectedOnce");
//       localStorage.removeItem("shortzRedirectedAt");
//     }

//     fetchDataFromBackend({ loading: true });
//     fetchRecentMatchesFromBackend();
//     fetchWeeklyMatchesFromBackend();
//     const intervalId = setInterval(() => {
//       if (!document.hidden) {
//         // fetchDataFromBackend({ loading: false });
//       }
//     }, 30000);
//     return () => clearInterval(intervalId);
//   }, []);

//   return (
//     <Layout active={1}>
//       <Drawer active={1} />
//       {loading ? (
//         <Loader />
//       ) : (
//         <>
//           <div className={classes.headingTop}>
//             <Heading
//               title={
//                 lang === "english"
//                   ? "Premier League"
//                   : lang === "spanish"
//                     ? "Premier League"
//                     : lang === "french"
//                       ? "Première Ligue"
//                       : lang === "arabic"
//                         ? "الدوري الممتاز"
//                         : "Premier League"
//               }
//             />
//           </div>
//           <MatchGridLayout>
//             <HeadingWithGrid
//               title={
//                 lang == "english"
//                   ? "Live Matches"
//                   : lang == "spanish"
//                     ? "Partidos en vivo"
//                     : lang == "french"
//                       ? "Matchs en direct"
//                       : lang == "arabic"
//                         ? "المباريات الحية"
//                         : "Live Matches"
//               }
//             />
//             {liveMatches?.length > 0 ? (
//               liveMatches?.map((match, index) => {
//                 return <MatchLayout match={match} key={index} />;
//               })
//             ) : (
//               <MessageBoxSimple
//                 title={
//                   lang == "english"
//                     ? "There are no live matches currently.."
//                     : lang == "spanish"
//                       ? "No hay partidos en vivo actualmente."
//                       : lang == "french"
//                         ? "Il n'y a pas de matchs en direct actuellement."
//                         : lang == "arabic"
//                           ? "لا توجد مباريات مباشرة حاليا.."
//                           : "There are no live matches currently.."
//                 }
//               />
//             )}
//             {todayMatches.length > 0 && (
//               <>
//                 <HeadingWithGrid
//                   title={
//                     lang == "english"
//                       ? "Upcoming Matches Today"
//                       : lang == "spanish"
//                         ? "Próximos partidos de hoy"
//                         : lang == "french"
//                           ? "Matchs à venir aujourd'hui"
//                           : lang == "arabic"
//                             ? "المباريات القادمة اليوم"
//                             : "Upcoming Matches Today"
//                   }
//                 />

//                 {todayMatches?.map((match, index) => {
//                   return <MatchLayout match={match} key={index} />;
//                 })}
//               </>
//             )}
//             {todayMatchesResults.length > 0 && (
//               <>
//                 <HeadingWithGrid
//                   title={
//                     lang == "english"
//                       ? "Today Matches Results"
//                       : lang == "spanish"
//                         ? "Resultados de los partidos de hoy"
//                         : lang == "french"
//                           ? "Résultats des matchs d'aujourd'hui"
//                           : lang == "arabic"
//                             ? "نتائج مباريات اليوم"
//                             : "Today Matches Results"
//                   }
//                 />

//                 {todayMatchesResults?.map((match, index) => {
//                   return <MatchLayout match={match} key={index} />;
//                 })}
//               </>
//             )}

//             {recentMatches?.length > 0 && (
//               <>
//                 <HeadingWithGrid
//                   title={
//                     lang == "english"
//                       ? "Recent Week Matches"
//                       : lang == "spanish"
//                         ? "Partidos de la semana reciente"
//                         : lang == "french"
//                           ? "Matchs de la semaine récente"
//                           : lang == "arabic"
//                             ? "مباريات الأسبوع الأخيرة"
//                             : "Recent Week Matches"
//                   }
//                 />
//                 {recentMatches?.map((match, index) => {
//                   return <MatchLayout match={match} key={index} />;
//                 })}
//               </>
//             )}

//             {weeklyMatches?.length > 0 && (
//               <>
//                 <HeadingWithGrid
//                   title={
//                     lang == "english"
//                       ? "Upcoming Week Matches"
//                       : lang == "spanish"
//                         ? "Partidos de la próxima semana"
//                         : lang == "french"
//                           ? "Matchs de la semaine à venir"
//                           : lang == "arabic"
//                             ? "مباريات الاسبوع القادم"
//                             : "Upcoming Week Matches"
//                   }
//                 />
//                 {weeklyMatches?.map((match, index) => {
//                   return <MatchLayout match={match} key={index} />;
//                 })}
//               </>
//             )}
//           </MatchGridLayout>
//           <Footer />
//         </>
//       )}
//     </Layout>
//   );
// };

// export default HomePage;



import React, { useEffect, useRef, useState } from "react";
 
import Layout from "../components/Layout";
import Drawer from "../components/Drawer";
import Loader from "../components/Loader";
import { toast } from "react-toastify";
import axios from "axios";
import {
  baseUrl,
  liveMatchesAllApi,
  liveMatchesApi,
  recentMatchesApi,
  weeklyMatchesApi,
} from "../api/api";
import moment from "moment-timezone";
import { useSelector } from "react-redux";
import MatchLayout from "../components/MatchLayout";
import classes from "../css/HomePage.module.css";
import { useNavigate } from "react-router-dom";
import MatchGridLayout from "../components/Match-Container/MatchGridLayout";
import HeadingWithGrid from "../components/Headings/HeadingWithGrid";
import MessageBoxSimple from "../components/Message-Box/MessageBoxSimple";
import Heading from "../components/Heading";
import Footer from "../components/Footer";
import Cookies from "js-cookie";
import NewsBox from "../pages/NewsBox";
// import { useSubscriptionGuard } from "../helpers/useSubscriptionGuard";
const HomePage = () => {
  const [loading, setLoading] = useState(true);
  const [matches, setMatches] = useState([]);
  const [recentMatches, setRecentMatches] = useState([]);
  const [liveMatches, setLiveMatches] = useState([]);
  const [todayMatches, setTodayMatches] = useState([]);
  const [todayMatchesResults, setTodayMatchesResults] = useState([]);
  const [weeklyMatches, setWeeklyMatches] = useState([]);
  const { lang } = useSelector((state) => state.langSlice);
 
  const navigate = useNavigate();
 
// useSubscriptionGuard();
 
  const fetchDataFromBackend = async (loader) => {
    try {
      if (loader?.loading) {
        setLoading(true);
      }
      const res = await axios.get(`${baseUrl}${liveMatchesApi}`, {
        timezone: moment.tz.guess(),
        date: moment().tz(moment.tz.guess()).format("YYYY-MM-DD"),
      });
 
      // const res = await axios.get(`${baseUrl}${liveMatchesAllApi}`);
 
      console.log(res, "res");
 
      setMatches(res?.data?.response?.data);
 
      // TODAY MATCHES PREMIERE LEAGUE
      setTodayMatches(
        res?.data?.response?.data.filter(
          (data) =>
            data.matchStatus != "Match Finished" && data.matchTime == null
        )
      );
 
      // LIVE MATCHES PREMIERE LEAGUE
      setLiveMatches(
        res?.data?.response?.data.filter(
          (data) =>
            data.matchTime != null && data.matchStatus != "Match Finished"
        )
      );
 
      const liveData = res.data.response.data.length;
      console.log("liveData ", liveData);
 
    
 
      // TODAY MATCHES RESULTS PREMIERE LEAGUE
      setTodayMatchesResults(
        res?.data?.response?.data.filter(
          (data) => data.matchStatus == "Match Finished"
        )
      );
 
      console.log(res, "response....");
      setLoading(false);
    } catch (error) {
      setLoading(false);
      // toast.error(
      //   error?.response?.data?.message ||
      //     error?.data?.message ||
      //     error?.message ||
      //     error
      // );
      console.log(error,'-err is home page')
    }
  };
 
  const fetchRecentMatchesFromBackend = async () => {
    try {
      setLoading(true);
      const res = await axios.get(`${baseUrl}${recentMatchesApi}`);
      console.log(res.data.response, "resssssssss recent");
      // setRecentMatches(
      //   res?.data?.response?.filter(
      //     (data) => data.matchStatus == "Match Finished"
      //   )
      // );
      const sortedMatches = res?.data?.response
        ?.filter((data) => data.matchStatus === "Match Finished")
        ?.sort(
          (a, b) =>
            moment
              .tz(
                b?.match_date_time ?? b?.time ?? b?.date,
                moment.tz.guess()
              )
              .valueOf() -
            moment
              .tz(
                a?.match_date_time ?? a?.time ?? a?.date,
                moment.tz.guess()
              )
              .valueOf()
        );
 
      setRecentMatches(sortedMatches);
      setLoading(false);
    } catch (error) {
      setLoading(false);
      toast.error(
        error?.data || error?.data?.message || "Something Went Wrong!"
      );
      console.log(error, "error");
    }
  };
 

 
const fetchWeeklyMatchesFromBackend = async () => {
  try {
    setLoading(true);
 
    const res = await axios.get(`${baseUrl}${weeklyMatchesApi}`, {
      timezone: moment.tz.guess(),
    });
 
    console.log(res.data.response, "response weekly matches");
 
    const sortedMatches = res?.data?.response
      ?.filter((data) => data.matchTime === null)
      ?.sort((a, b) => new Date(a.time) - new Date(b.time)); // chronological order
 
    setWeeklyMatches(sortedMatches);
 
console.log(sortedMatches,"====soretedmatchess======");
 
    setLoading(false);
  } catch (error) {
    setLoading(false);
    toast.error(
      error?.data || error?.data?.message || "Something Went Wrong!"
    );
    console.log(error, "error");
  }
};
 
  useEffect(() => {
    // ✅ Clear redirect flag if older than 1 day
    const redirectTimestamp = localStorage.getItem("shortzRedirectedAt");
    const now = Date.now();
 
    //one hout
 
    if (redirectTimestamp && now - redirectTimestamp > 3600000) {
      localStorage.removeItem("shortzRedirectedOnce");
      localStorage.removeItem("shortzRedirectedAt");
    }
 
    fetchDataFromBackend({ loading: true });
    fetchRecentMatchesFromBackend();
    fetchWeeklyMatchesFromBackend();
    const intervalId = setInterval(() => {
      if (!document.hidden) {
        // fetchDataFromBackend({ loading: false });
      }
    }, 30000);
    return () => clearInterval(intervalId);
  }, []);
 
  return (
    <Layout active={1}>
      <Drawer active={1} />
      {loading ? (
        <Loader />
      ) : (
        <>
          <div className={classes.heading}>
            <Heading
              title={
                lang === "english"
                  ? "Premier League"
                  : lang === "spanish"
                  ? "Premier League"
                  : lang === "french"
                  ? "Première Ligue"
                  : lang === "arabic"
                  ? "الدوري الممتاز"
                  : "Premier League"
              }
            />
          </div>
          <MatchGridLayout>
            <HeadingWithGrid
              title={
                lang == "english"
                  ? "Live Matches"
                  : lang == "spanish"
                  ? "Partidos en vivo"
                  : lang == "french"
                  ? "Matchs en direct"
                  : lang == "arabic"
                  ? "المباريات الحية"
                  : "Live Matches"
              }
            />
            {liveMatches?.length > 0 ? (
              liveMatches?.map((match, index) => {
                return <MatchLayout match={match} key={index} />;
              })
            ) : (
              <MessageBoxSimple
                title={
                  lang == "english"
                    ? "There are no Premier League live matches currently.."
                    : lang == "spanish"
                    ? "No hay partidos en vivo actualmente."
                    : lang == "french"
                    ? "Il n'y a pas de matchs en direct actuellement."
                    : lang == "arabic"
                    ? "لا توجد مباريات مباشرة حاليا.."
                    : "There are no live matches currently.."
                }
              />
            )}
            {todayMatches.length > 0 && (
              <>
                <HeadingWithGrid
                  title={
                    lang == "english"
                      ? "Upcoming Matches Today"
                      : lang == "spanish"
                      ? "Próximos partidos de hoy"
                      : lang == "french"
                      ? "Matchs à venir aujourd'hui"
                      : lang == "arabic"
                      ? "المباريات القادمة اليوم"
                      : "Upcoming Matches Today"
                  }
                />
 
                {todayMatches?.map((match, index) => {
                  return <MatchLayout match={match} key={index} />;
                })}
              </>
            )}
            {todayMatchesResults.length > 0 && (
              <>
                <HeadingWithGrid
                  title={
                    lang == "english"
                      ? "Today Matches Results"
                      : lang == "spanish"
                      ? "Resultados de los partidos de hoy"
                      : lang == "french"
                      ? "Résultats des matchs d'aujourd'hui"
                      : lang == "arabic"
                      ? "نتائج مباريات اليوم"
                      : "Today Matches Results"
                  }
                />
 
                {todayMatchesResults?.map((match, index) => {
                  return <MatchLayout match={match} key={index} />;
                })}
              </>
            )}
             { <div className={classes.newsBoxWrapper}>
              <NewsBox />
            </div> }
 
            {recentMatches?.length > 0 && (
              <>
                <HeadingWithGrid
                  title={
                    lang == "english"
                      ? "Recent Week Matches"
                      : lang == "spanish"
                      ? "Partidos de la semana reciente"
                      : lang == "french"
                      ? "Matchs de la semaine récente"
                      : lang == "arabic"
                      ? "مباريات الأسبوع الأخيرة"
                      : "Recent Week Matches"
                  }
                />
                {recentMatches?.map((match, index) => {
                  return <MatchLayout match={match} key={index} />;
                })}
              </>
            )}
           
 
            {weeklyMatches?.length > 0 && (
              <>
                <HeadingWithGrid
                  title={
                    lang == "english"
                      ? "Upcoming Week Matches"
                      : lang == "spanish"
                      ? "Partidos de la próxima semana"
                      : lang == "french"
                      ? "Matchs de la semaine à venir"
                      : lang == "arabic"
                      ? "مباريات الاسبوع القادم"
                      : "Upcoming Week Matches"
                  }
                />
                {weeklyMatches?.map((match, index) => {
                  return <MatchLayout match={match} key={index} />;
                })}
              </>
            )}
          </MatchGridLayout>
          <Footer />
        </>
      )}
    </Layout>
  );
};
 
export default HomePage;